module.exports = __webpack_public_path__ + "img/paycek-logo.53b1a2c3.svg";